import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { adminRole } from '../access-roles/admin.role'
import { customerRole } from '../access-roles/customer.role'
import { employeeRole } from '../access-roles/employee.role'
import {RoleModel} from "../../shared/models/role/role.model";
import {MeModel} from "../../shared/models/login/me.model";
import {sidenavConfig} from "../../shared/constants/sidenav.config";
import {externalRole} from "../access-roles/external.role";

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {
  private tokenKey: string = 'TOKEN'
  private refreshTokenKey: string = 'REFRESH_TOKEN'
  private nameKey: string = 'NAME'
  private userNameKey: string = 'USER_NAME'
  private roleNameKey: string = 'ROLE_NAME'
  private roleCodeKey: string = 'ROLE_CODE'
  private customerIdKey: string = 'CUSTOMER_ID'

  constructor( private _router: Router ) { }

  /**
   * @description get role set according to role code
   * @returns RoleModel
   */
  private getRoleSet(roleCode: number): RoleModel {
    switch (roleCode) {
      case customerRole.code:
        return customerRole
      case employeeRole.code:
        return employeeRole
      case adminRole.code:
        return adminRole
      case externalRole.code:
        return externalRole
      default:
        throw new Error('Unsupported role Code: ' + roleCode)
    }
  }

  /**
   * @description methord checks if the user is authorized that is logged in or not.
   * @returns boolean
   */
  public isAuthorized(): boolean {
    return !!localStorage.getItem(this.tokenKey)
  }

  /**
   * @description methord takes the token and saves it to the local storage.
   * @param  {string} bearerToken
   * @param  {string} refreshToken
   * @returns boolean
   */
  public setToken(bearerToken: string, refreshToken: string): boolean {
    try {
      localStorage.setItem(this.tokenKey,bearerToken)
      localStorage.setItem(this.refreshTokenKey,refreshToken)
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  }

  /**
   * @description retrieves the bearer token from local storage.
   * @returns string
   */
  public getBearerToken(): string {
    return localStorage.getItem(this.tokenKey)
  }

  /**
   * @description retrieves the refresh token from local storage.
   * @returns string
   */
  public getRefreshToken(): string {
    return localStorage.getItem(this.refreshTokenKey)
  }

  /**
   * @description logs out user from the system.
   * @returns void
   */
  public logout(): Promise<boolean> {
    localStorage.clear()
    return this._router.navigate(['login'])
  }

  /**
   * @description set the me response in local storage.
   * @param  {MeModel} data
   * @returns boolean
   */
  public setMe(data: MeModel): boolean {
    try {
      localStorage.setItem(this.nameKey,data.name)
      localStorage.setItem(this.userNameKey,data.username)
      localStorage.setItem(this.roleNameKey,data.role.name)
      localStorage.setItem(this.roleCodeKey,(data.role.code).toString())
      localStorage.setItem(this.customerIdKey,data._customerId)
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  }

  /**
   * @description get name of the user.
   * @returns string
   */
  public getName(): string {
    return localStorage.getItem(this.nameKey)
  }

  /**
   * @description get role code.
   * @returns number
   */
  public getRoleCode(): number {
    return parseInt(localStorage.getItem(this.roleCodeKey))
  }

  /**
   * @description get the access value according to the module and action.
   * @param  {string} module
   * @param  {string} action
   * @returns boolean
   */
  public getAccessValue(module: string, action: string): boolean {
    const roleSet = this.getRoleSet(this.getRoleCode())
    return roleSet[module][action]
  }

  /**
   * @description this methord returns the nav settings for rendering according to the role.
   * @returns any
   */
  public getNavMenu(): any[] {
    const activeNav = []
    sidenavConfig.forEach(element => {
      if (this.getAccessValue(element.module,'view')) {
        activeNav.push(element)
      }
    })
    return activeNav
  }
}
